import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  footerWrapper: {
    padding: theme.spacing(6, 0, 0),
    flexDirection: 'column-reverse',
    justifyContent: 'space-between',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(6, 16, 0),
    },
    [theme.breakpoints.up('mxl')]: {
      flexDirection: 'row',
      padding: theme.spacing(9, 15, 0),
    },
    textAlign: 'center',
    '& svg': {
      width: theme.spacing(5.5),
      height: theme.spacing(5.5),
      margin: theme.spacing(3, 1),
    },
  },
  links: {
    '&>a': {
      color: theme.palette.footer.text,
      fontWeight: 500,
      fontSize: '1.125rem',
      textAlign: 'start',
      marginBottom: theme.spacing(3),
      transition: 'transform 200ms ease-in-out',
    },
    display: 'flex',
    flexDirection: 'column',
    paddingTop: theme.spacing(8),
    [theme.breakpoints.up('mxl')]: {
      paddingTop: theme.spacing(0),
    },
    marginBottom: theme.spacing(2.5),
  },
  iconLinks: {
    display: 'flex',
    flexDirection: 'column-reverse',
    gap: theme.spacing(10),
    [theme.breakpoints.up('mxl')]: {
      gap: theme.spacing(5),
      flexDirection: 'column',
    },
  },
  downloadLinks: {
    display: 'flex',
    gap: theme.spacing(5),
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    [theme.breakpoints.up('mxl')]: {
      justifyContent: 'end',
    },
    '&>*': {
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
      width: '45%',
      [theme.breakpoints.up('sm')]: {
        width: 'auto',
      },
    },
    '& svg': { margin: 0, border: '0.5px solid white', borderRadius: '4px' },
  },
  footerLinksWrapper: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3, 0, 9),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(3, 16, 10),
    },
    [theme.breakpoints.up('mxl')]: {
      padding: theme.spacing(0, 15, 9),
    },
  },

  copyright: {
    textAlign: 'center',
    margin: theme.spacing(0),
    'p&': {
      marginBottom: theme.spacing(5),
      width: '100%',
    },
    color: theme.palette.footer.text,
    fontSize: '0.75rem',
    fontWeight: 'normal',
    [theme.breakpoints.up('mxl')]: {
      textAlign: 'start',
      'p&': {
        marginBottom: theme.spacing(8),
        width: 'auto',
      },
    },
  },

  footerLinks: {
    display: 'flex',
    justifyContent: 'space-between',
    flexFlow: 'row wrap',
    padding: theme.spacing(0, 6),
    gap: theme.spacing(1),
    alignContent: 'center',
  },

  bsfInfo: {
    marginTop: theme.spacing(5),
    textAlign: 'center',
    padding: theme.spacing(3, 0),
    color: theme.palette.footer.text,
    fontSize: '1rem',
    '& p:first-child': {
      marginBottom: 0,
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(3, 16),
    },
    [theme.breakpoints.up('mxl')]: {
      padding: theme.spacing(0, 15, 3),
      textAlign: 'start',
    },
  },
}))
